export class User {
  member: {
    profilePicture: string;
    id: number;
    name: string;
    requestKey: string;
    firstName: string;
    lastName: string;
  };
  isAdmin: boolean;
  isEvaluator: boolean;
  isProgramManager: boolean;
  individualAccess: {
    allowComment: boolean,
    allowEdit: boolean
  };
  expanded: boolean;

  constructor(
    profilePicture: string = "",
    id: number = 0,
    name: string = "",
    firstName: string = "",
    lastName: string = "",
    requestKey: string = "",
    isAdmin: boolean = false,
    isEvaluator: boolean = false,
    isProgramManager: boolean = false,
    allowComment: boolean = false,
    allowEdit: boolean = false
  ) {
    this.member = {
      profilePicture: profilePicture,
      id: id,
      name: name,
      requestKey: requestKey,
      firstName: firstName,
      lastName: lastName
    };

    this.isAdmin = isAdmin;
    this.isEvaluator = isEvaluator;
    this.isProgramManager = isProgramManager;

    this.individualAccess = {
      allowComment: allowComment,
      allowEdit: allowEdit
    }
    this.expanded = false;
  }
}
